export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13699.059ae8eb.jpg";